import script from "./headerSection.vue?vue&type=script&setup=true&lang=js"
export * from "./headerSection.vue?vue&type=script&setup=true&lang=js"

import "./headerSection.vue?vue&type=style&index=0&id=6b7219a4&lang=css"

const __exports__ = script;

export default __exports__